/**
 *
 */
declare var gtag: any;

/**
 *
 */
const setupTrackedEvents = () =>
{
	const links = document.querySelectorAll( 'a[data-track-click]' );

	links.forEach( link =>
	{
		link.addEventListener( 'click', () =>
		{
			const eventName = link.getAttribute( 'data-track-click' );

			if (eventName === 'Ro2_Water_Page_Views') {

				if (gtag) {
					gtag( 'event', 'conversion', {
						'allow_custom_scripts': true,
						'send_to':              'DC-16796464/water0/ro2_w0+unique'
					} );

					/*
					console.log( gtag );

					gtag( 'get', 'G-8FF9F375DT', 'client_id', ( client_id ) =>
					{
						console.log( client_id );
					} );

					 */

					setTimeout( () => location.replace( 'https://google.com' ), 5000 );
				}
			}
		} );
	} );
};


/**
 *
 */
export default setupTrackedEvents;